// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"377":"dbeeb157","880":"483b9737"}[chunkId] + ".chunk.js";
};